import { Component, Input, ElementRef, OnInit, Inject } from '@angular/core';

@Component({
    selector: 'icc-form-field',
    templateUrl: './form-field.component.html',
    styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent implements OnInit {
    private _size: 'large' | 'medium' | 'small' = 'large';

    @Input()
    get size() {
        return this._size;
    }
    set size(size: 'large' | 'medium' | 'small') {
        this._size = size;
    }

    private hasIcon = false;
    private hasInput = false;
    private hasLabel = false;

    private inputElement!: Element;
    private selectElement!: Element;

    constructor(@Inject(ElementRef) private readonly elementRef: ElementRef<HTMLElement>) {}

    ngOnInit() {
        this.handleChildren();
        this.handleSize();
        this.handleClasses();
        this.handleChildrenClasses();
    }

    protected handleChildren() {
        if (this.elementRef?.nativeElement?.children[0]?.children[0]?.children) {
            const children = this.elementRef.nativeElement.children[0].children[0].children;

            Object.values(children).map((e) => {
                if (e.tagName.toLowerCase() === 'icc-icon') {
                    this.hasIcon = true;
                }
                if (e.tagName.toLowerCase() === 'icc-input') {
                    this.hasInput = true;
                    this.inputElement = e;
                }
                if (e.tagName.toLowerCase() === 'icc-select') {
                    this.hasInput = true;
                    this.selectElement = e;
                }
                if (e.tagName.toLowerCase() === 'icc-label') {
                    this.hasLabel = true;
                }
            });
        }
    }

    protected handleSize() {
        if (this.elementRef?.nativeElement?.classList?.value) {
            const classes = this.elementRef?.nativeElement?.classList;
            if (classes.value.includes('icc-size-large')) {
                this._size = 'large';
            }
            if (classes.value.includes('icc-size-medium')) {
                this._size = 'medium';
            }
            if (classes.value.includes('icc-size-small')) {
                this._size = 'small';
            }
        }
    }

    protected handleClasses() {
        if (this.elementRef?.nativeElement) {
            const element = this.elementRef.nativeElement as HTMLElement;
            const frameElement = element?.children[0]?.children[0];
            element.classList.add('icc-size-' + this._size);

            if (frameElement) {
                if (this.hasIcon) {
                    frameElement.classList.add('has-icon');
                }

                if (this.hasInput) {
                    frameElement.classList.add('has-input');
                }

                if (this.hasLabel) {
                    frameElement.classList.add('has-label');
                }
            }
        }
    }

    protected handleChildrenClasses() {
        if (this.elementRef?.nativeElement) {
            if (this.inputElement) {
                this.inputElement.classList.add('icc-size-' + this._size);
            }
            if (this.selectElement) {
                this.selectElement.classList.add('icc-size-' + this._size);
            }
        }
    }
}
